module.exports = __webpack_public_path__ + "img/43_80.af038054.png";